import React, { useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import Menu from './Menu'
import Header from './Header';
import CustomProgressContainer from '../ui/CustomProgressContainer';
import DracoUXContainer from "../ui/DracoUXContainer"
import { DracoCommandContext } from "../context/DracoCommandContext";

function Layout() {

  const DracoUXRef = useRef();

  // DracoUX 콜백
  const [commandHandler, setCommandHandler] = useState(null);

  const handleReceiveCommand = (command) => {
    if (commandHandler) {
      commandHandler(command);
    } else {
      console.warn("No command handler registered.");
    }
  };

  return (

    <DracoCommandContext.Provider value={{ setCommandHandler }}>
      <div style={{ display: 'flex', minHeight: '100%' }}>

        <CustomProgressContainer />

        <Menu />

        <div className="page-content-wrapper">

          <Header />

          <main className="page-content">          
              <Outlet />
              <DracoUXContainer ref={DracoUXRef} reciveCommand={handleReceiveCommand}/>         
          </main>

        </div>

      </div>
    </DracoCommandContext.Provider>
  );
}

export default Layout;
